import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePostV1IndividualsByIndividualIdDocumentsByDocumentIdFiles } from '../client/queries'
import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

export const useAddFilesToDocument = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdDocumentsByDocumentIdFiles({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
